import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8173b93a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filmEditing" }
const _hoisted_2 = { class: "flex between" }
const _hoisted_3 = { class: "video-title-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "视频名称：", -1))
const _hoisted_5 = { class: "video-title-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "视频长度：", -1))
const _hoisted_7 = { class: "custom-video_container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  id: "welcomeVideo",
  class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "filmEditing-bottom" }
const _hoisted_11 = { class: "crop-range video-btn" }
const _hoisted_12 = { class: "crop-input crop-start" }
const _hoisted_13 = { class: "video-controls-box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "thumbs",
  id: "thumbs"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner" })
], -1))
const _hoisted_15 = { class: "control-bars" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "80px",
  height: "24px",
  viewBox: "0 0 54 21",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Page-1",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M27,23 L27,24 L26,24 L26,23 C26,20.2385763 23.7614237,18 21,18 L9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 L45,0 C49.9705627,0 54,4.02943725 54,9 C54,13.9705627 49.9705627,18 45,18 L32,18 L32,18 C29.2385763,18 27,20.2385763 27,23 Z",
      id: "time_bg",
      fill: "#FFFFFF"
    })
  ])
], -1))
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { class: "crop-range video-btn" }
const _hoisted_19 = { class: "crop-input crop-end" }
const _hoisted_20 = { class: "flex between" }
const _hoisted_21 = { class: "toggle-box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"54px"} }, "重置", -1))
const _hoisted_23 = { class: "footer" }

import { ref, onMounted, computed, watch, onUnmounted, nextTick, inject } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import http from '@/api/media';
import { useHomeStore } from '@/pinia/home';

interface Info {
  video_id: string | any;
  project_id: string | any;
  project_title: string | any;
  mVideo: boolean;
  blobURL: string | any;
  play_Url: string | any;
  videoEdit: {
    start: number | any;
    center: number | any;
    end: number | any;
    duration: number | any;
    play: boolean | any;
    currentPosition: number | any;
  };
  videoDom: number | any;
  duration: number | any;
  currentTime: number | any;
  leftMovePercentage: number | any;
  leftMoveInit: number | any;
  rightMovePercentage: number | any;
  rightMoveInit: number | any;
  direction: string | any;
  disBtn: boolean;
  source: string | any;
}
interface init {
  handleMoveStatus: boolean;
  thumbsWidth: number;
  handleMoveDirection: any;
  leftIconDom: any;
  rightIconDom: any;
  minWidthPercentage: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoClip',
  setup(__props) {

const route = useRoute();
const homeStore = useHomeStore();
const loadVideojs: any = inject('loadVideojs');

const dataInfo = ref<Info>({
  video_id: '',
  project_id: '', // 云剪辑工程id
  project_title: '',
  mVideo: false,
  blobURL: '',
  play_Url: '',
  videoEdit: {
    start: 0,
    center: 0,
    end: 0,
    duration: 0,
    play: false, // 播放状态
    currentPosition: 0, // 当前播放点距离左边的百分比
  },
  videoDom: null, // video
  duration: 0, // 视频总时长
  currentTime: 0, // 视频当前播放时长
  leftMovePercentage: 0, // 进度条左边圆点 距左边距离
  leftMoveInit: 0,
  rightMovePercentage: 0, // 进度条右边圆点 距右边距离
  rightMoveInit: 0,
  // videoShow: true
  direction: '', // 点击左边圆点或右边圆点状态
  disBtn: false, // 防止多次点击保存
  source: '', // 0阿里剪辑 1腾讯剪辑
});
const initInfo = ref<init>({
  handleMoveStatus: false,
  thumbsWidth: 0,
  handleMoveDirection: '',
  leftIconDom: '',
  rightIconDom: '',
  minWidthPercentage: 0,
});

const initCreate = () => {
  document.title = route.query.title + ' - 剪辑'; // 修改页面的标题
  // "管理平台 - " +
  dataInfo.value.source = route.query.source; // 0阿里剪辑 1腾讯剪辑
  dataInfo.value.video_id = route.query.video_id;
  dataInfo.value.project_id = route.query.project_id;
  dataInfo.value.project_title = route.query.title;
  dataInfo.value.blobURL = route.query.video_url;
  dataInfo.value.play_Url = route.query.video_url;

  let index = dataInfo.value.play_Url.lastIndexOf('.'); //获取点的位置
  let suffix = dataInfo.value.play_Url.substring(index + 1);
  if (suffix == 'm3u8') {
    dataInfo.value.mVideo = true;
  } else if (suffix == 'mp4') {
    dataInfo.value.mVideo = false;
  }
};
const toInt = (val: any) => {
  return parseInt(val) || 0;
};
// 时间转化
const timeTranslate = (t: number) => {
  // 时间转化
  let hr: any = Math.floor((t / 3600) % 24);
  if (hr < 10) {
    hr = '0' + Math.floor((t / 3600) % 24);
  }
  let m: any = Math.floor((t / 60) % 60);
  m < 10 && (m = '0' + m);
  return hr + ':' + m + ':' + ((t % 60) / 100).toFixed(2).slice(-2);
};
const inputStartLeftTime = computed(() => {
  const set = (val: any) => {
    val = val * 3600 + toInt((document.getElementById('range-2') as any).value);
    if (val > dataInfo.value.videoEdit.duration || dataInfo.value.videoEdit.duration - val < 10) {
      val = 0;
    }
    dataInfo.value.videoEdit.start = val;
  };
  const get = () => {
    return timeTranslate(dataInfo.value.videoEdit.start).split(':')[0];
  };
  return get();
});
const inputStartCenterTime = computed(() => {
  const set = (val: any) => {
    val = val * 60 + toInt((document.getElementById('range-1') as any).value);
    if (val > dataInfo.value.videoEdit.duration || dataInfo.value.videoEdit.duration - val < 10) {
      val = 0;
    }
    dataInfo.value.videoEdit.start = val;
  };
  const get = () => {
    return timeTranslate(dataInfo.value.videoEdit.start).split(':')[1];
  };
  return get();
});
const inputStartRightTime = computed(() => {
  const set = (val: any) => {
    val = toInt((document.getElementById('range-0') as any).value) * 60 + val;
    if (val > dataInfo.value.videoEdit.duration || dataInfo.value.videoEdit.duration - val < 10) {
      val = 0;
    }
    dataInfo.value.videoEdit.start = val;
  };
  const get = () => {
    return timeTranslate(dataInfo.value.videoEdit.start).split(':')[2];
  };
  return get();
});
const inputEndLeftTime = computed(() => {
  const set = (val: any) => {
    val = val * 3600 + toInt((document.getElementById('range-2') as any).value);
    if (val > dataInfo.value.videoEdit.duration || val - dataInfo.value.videoEdit.start < 10) {
      val = dataInfo.value.videoEdit.duration;
    }
    dataInfo.value.videoEdit.end = val;
  };
  const get = () => {
    return timeTranslate(dataInfo.value.videoEdit.end).split(':')[0];
  };
  return get();
});
const inputEndCenterTime = computed(() => {
  const set = (val: any) => {
    val = val * 60 + toInt((document.getElementById('range-2') as any).value);
    if (val > dataInfo.value.videoEdit.duration || val - dataInfo.value.videoEdit.start < 10) {
      val = dataInfo.value.videoEdit.duration;
    }
    dataInfo.value.videoEdit.end = val;
  };
  const get = () => {
    return timeTranslate(dataInfo.value.videoEdit.end).split(':')[1];
  };
  return get();
});
const inputEndRightTime = computed(() => {
  const set = (val: any) => {
    val = toInt((document.getElementById('range-2') as any).value) * 60 + val;
    if (val > dataInfo.value.videoEdit.duration || val - dataInfo.value.videoEdit.start < 10) {
      val = dataInfo.value.videoEdit.duration;
    }
    dataInfo.value.videoEdit.end = val;
  };
  const get = () => {
    return timeTranslate(dataInfo.value.videoEdit.end).split(':')[2];
  };
  return get();
});
const startHandler = (val: any) => {
  dataInfo.value.currentTime = val;
  dataInfo.value.videoEdit.currentPosition = (dataInfo.value.currentTime / dataInfo.value.videoEdit.duration) * 100;
  dataInfo.value.leftMovePercentage = dataInfo.value.videoEdit.currentPosition;
};
watch(
  () => dataInfo.value.videoEdit.start,
  (nv, ov) => {
    startHandler(nv);
  }
);
const endHandler = (val: any) => {
  dataInfo.value.currentTime = val;
  dataInfo.value.videoEdit.currentPosition = (dataInfo.value.currentTime / dataInfo.value.videoEdit.duration) * 100;
  dataInfo.value.rightMovePercentage = 100 - dataInfo.value.videoEdit.currentPosition;
};
watch(
  () => dataInfo.value.videoEdit.end,
  (nv, ov) => {
    endHandler(nv);
  }
);
watch(
  () => initInfo.value.handleMoveStatus,
  () => {
    if (initInfo.value.handleMoveStatus) {
      document.onkeydown = function (e) {
        let key = window.event.keyCode;
        if (key == 37) {
          leftdot_left(e);
        }
        if (key == 39) {
          leftdot_right(e);
        }
      };
    }
  }
);

// 左边圆点点击事件
const leftdotClick = () => {
  dataInfo.value.direction = 'left';
};
// 右边圆点点击事件
const rightdotClick = () => {
  dataInfo.value.direction = 'right';
};
const leftdot_left = (ev: any) => {
  if (dataInfo.value.direction == 'left') {
    if (dataInfo.value.videoEdit.start < 1) {
      dataInfo.value.videoEdit.start = 0;
    } else {
      dataInfo.value.videoEdit.start = dataInfo.value.videoEdit.start - 1;
    }
  }
  if (dataInfo.value.direction == 'right') {
    if (dataInfo.value.videoEdit.end > dataInfo.value.videoEdit.start + 10)
      dataInfo.value.videoEdit.end = dataInfo.value.videoEdit.end - 1;
  }
  handleClick(ev, initInfo.value.handleMoveDirection);
};
const leftdot_right = (ev: any) => {
  if (dataInfo.value.direction == 'left') {
    if (dataInfo.value.videoEdit.start < dataInfo.value.videoEdit.end - 10)
      dataInfo.value.videoEdit.start = dataInfo.value.videoEdit.start + 1;
  }
  if (dataInfo.value.direction == 'right') {
    if (dataInfo.value.videoEdit.end < dataInfo.value.videoEdit.duration)
      dataInfo.value.videoEdit.end = dataInfo.value.videoEdit.end + 1;
  }
  handleClick(ev, initInfo.value.handleMoveDirection);
};
const throttle = (fn: any, threshold: any, scope: any) => {
  let timer: any;
  return function () {
    const context = scope || this;
    const args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        fn.apply(context, args);
        timer = null;
      }, threshold);
    }
  };
};
// 初始化video相关事件
const initMedaData = () => {
  dataInfo.value.videoDom.addEventListener('loadedmetadata', () => {
    // 获取视频总时长
    dataInfo.value.videoEdit.duration = dataInfo.value.videoDom.duration; // 视频总时长
    dataInfo.value.videoEdit.end = dataInfo.value.videoEdit.duration;
  });
  // const self = this;

  dataInfo.value.videoDom.addEventListener('timeupdate', () => {
    // 监听视频播放过程中的时间
    dataInfo.value.videoEdit.currentPosition = (dataInfo.value.videoDom.currentTime / dataInfo.value.videoEdit.duration) * 100;
    dataInfo.value.currentTime = dataInfo.value.videoDom.currentTime;
    if (dataInfo.value.videoEdit.end - dataInfo.value.currentTime < 0.01 && dataInfo.value.videoEdit.play) {
      playEnd();
    }
  });
};
// 初始化相关元数据
const videoInit = () => {
  dataInfo.value.videoDom = document.getElementById('welcomeVideo_html5_api');
  initInfo.value.leftIconDom = document.getElementById('move_left_icon');
  initInfo.value.rightIconDom = document.getElementById('move_right_icon');
  initInfo.value.thumbsWidth = (document.getElementById('thumbs') as any).clientWidth;
  dataInfo.value.leftMoveInit = getOffset(initInfo.value.leftIconDom, '').left + 5;
  dataInfo.value.rightMoveInit = getOffset(initInfo.value.rightIconDom, '').left + 5;
  initInfo.value.minWidthPercentage = ((20 / initInfo.value.thumbsWidth) * 100).toFixed(4); // 最小裁剪区域所占百分比
  initMedaData();

  document.addEventListener('mouseup', (ev) => {
    initInfo.value.handleMoveStatus = false;
  });
  document.addEventListener('mousemove', (ev) => {
    if (!initInfo.value.handleMoveStatus) return;
    if (initInfo.value.handleMoveDirection === 'left') {
      const distanceMoveXLeft = ev.clientX - dataInfo.value.leftMoveInit;

      dataInfo.value.leftMovePercentage =
        distanceMoveXLeft > 0 ? ((distanceMoveXLeft / (initInfo.value.thumbsWidth - 20)) * 100).toFixed(4) : 0;
      // 控制裁剪百分比最小值
      if (dataInfo.value.leftMovePercentage > 100 - dataInfo.value.rightMovePercentage - initInfo.value.minWidthPercentage) {
        dataInfo.value.leftMovePercentage = 100 - dataInfo.value.rightMovePercentage - initInfo.value.minWidthPercentage;
      }

      dataInfo.value.videoEdit.start = ((dataInfo.value.videoEdit.duration * dataInfo.value.leftMovePercentage) / 100).toFixed(4);
    }
    if (initInfo.value.handleMoveDirection === 'right') {
      const distanceMoveXRight = dataInfo.value.rightMoveInit - ev.clientX;

      dataInfo.value.rightMovePercentage =
        distanceMoveXRight > 0 ? ((distanceMoveXRight / (initInfo.value.thumbsWidth - 20)) * 100).toFixed(4) : 0;

      // 控制裁剪百分比最小值
      if (dataInfo.value.rightMovePercentage > 100 - dataInfo.value.leftMovePercentage - initInfo.value.minWidthPercentage) {
        dataInfo.value.rightMovePercentage = 100 - dataInfo.value.leftMovePercentage - initInfo.value.minWidthPercentage;
      }

      dataInfo.value.videoEdit.end = (dataInfo.value.videoEdit.duration * (1 - dataInfo.value.rightMovePercentage / 100)).toFixed(
        4
      );
    }
    handleClick(ev, initInfo.value.handleMoveDirection);
  });
};

// 播放暂停按钮事件
const togglePlayStatus = () => {
  dataInfo.value.videoEdit.play ? toggleVideoPause() : toggleVideoPlay();
};
// 处理当前位置在末尾的时候先初始化开始播放时间
const toggleVideoPlay = () => {
  if (dataInfo.value.videoEdit.end - dataInfo.value.currentTime < 0.01) {
    dataInfo.value.videoDom.currentTime = dataInfo.value.videoEdit.start;
  }
  // 为了取消当前点平滑移动到开始点的过渡
  setTimeout(() => {
    dataInfo.value.videoDom.play();
    dataInfo.value.videoEdit.play = true;
  }, 50);
};
const toggleVideoPause = () => {
  dataInfo.value.videoDom.pause();
  dataInfo.value.videoEdit.play = false;
};
const playEnd = () => {
  dataInfo.value.videoDom.currentTime = dataInfo.value.videoEdit.start;
  dataInfo.value.videoDom.pause();
  dataInfo.value.videoEdit.play = false;
};
const handleMoveDown = (ev: any, direction: any) => {
  initInfo.value.handleMoveStatus = true;
  initInfo.value.handleMoveDirection = direction;
  toggleVideoPause();
  handleClick(ev, direction);
};
// 区分各种情况是为了获取各种情况的当前播放点更准确
const handleClick = (ev: any, direction: any) => {
  if (direction === 'left') {
    dataInfo.value.videoEdit.currentPosition = dataInfo.value.leftMovePercentage;
  } else if (direction === 'right') {
    dataInfo.value.videoEdit.currentPosition = 100 - dataInfo.value.rightMovePercentage;
  } else {
    // 点击中间剪辑区域
    dataInfo.value.videoEdit.currentPosition = ((ev.clientX - dataInfo.value.leftMoveInit) / initInfo.value.thumbsWidth) * 100;
  }
  dataInfo.value.currentTime = ((dataInfo.value.videoEdit.currentPosition * dataInfo.value.videoEdit.duration) / 100).toFixed(4);
  dataInfo.value.videoDom.currentTime = dataInfo.value.currentTime;

  // 处理两边 mask 点击而非滑动时,拖拽区域的处理
  if (ev.target.dataset.direction === 'left' && !initInfo.value.handleMoveStatus) {
    dataInfo.value.leftMovePercentage = dataInfo.value.videoEdit.currentPosition;
    dataInfo.value.videoEdit.start = dataInfo.value.currentTime;
  }
  if (ev.target.dataset.direction === 'right' && !initInfo.value.handleMoveStatus) {
    dataInfo.value.rightMovePercentage = 100 - dataInfo.value.videoEdit.currentPosition;
    dataInfo.value.videoEdit.end = dataInfo.value.currentTime;
  }
  // 百分比取最大值：100 最小值：0
  dataInfo.value.videoEdit.currentPosition =
    dataInfo.value.videoEdit.currentPosition > 100 ? 100 : dataInfo.value.videoEdit.currentPosition;
  dataInfo.value.videoEdit.currentPosition =
    dataInfo.value.videoEdit.currentPosition < 0 ? 0 : dataInfo.value.videoEdit.currentPosition;
};

// 获取当前屏幕下进度条的左偏移量和又偏移量
const getOffset = (node: any, offset: any) => {
  if (!offset) {
    offset = {};
    offset.left = 0;
    offset.top = 0;
  }
  if (node === document.body || node === null) {
    return offset;
  }
  offset.top += node.offsetTop;
  offset.left += node.offsetLeft;
  return getOffset(node.offsetParent, offset);
};
// 重置
const reSet = () => {
  dataInfo.value.videoEdit.start = 0;
  dataInfo.value.videoEdit.end = dataInfo.value.videoEdit.duration;
  dataInfo.value.leftMovePercentage = 0;
  dataInfo.value.rightMovePercentage = 0;
};
// 取消剪辑
const Cancel = () => {
  router.push('/media/videos');
};
// 保存剪辑
const saveEditing = () => {
  if (dataInfo.value.source == 0) {
    //阿里剪辑
    dataInfo.value.leftMovePercentage = String(dataInfo.value.leftMovePercentage).replace(/^(.*\..{4}).*$/, '$1');
    dataInfo.value.rightMovePercentage = String(dataInfo.value.rightMovePercentage).replace(/^(.*\..{4}).*$/, '$1');
    // let duration = dataInfo.value.rightMovePercentage - dataInfo.value.leftMovePercentage;
    if (dataInfo.value.leftMovePercentage == 0 && dataInfo.value.rightMovePercentage == 0) {
      message.error('你还没有操作剪辑,无法进行保存！');
    } else {
      dataInfo.value.disBtn = true;
      let time_line = {
        Id: dataInfo.value.project_id,
        Title: dataInfo.value.project_title,
        CreationTime: dataInfo.value.videoEdit.start,
        ModifiedTime: dataInfo.value.videoEdit.end,
      };
      let params = {
        media_line: dataInfo.value.videoEdit.duration,
        project_id: dataInfo.value.project_id,
        media_id: dataInfo.value.video_id,
        time_line: JSON.stringify(time_line),
        title: dataInfo.value.project_title,
        video_url: route.query.video_url,
      };
      http
        .buildMediaMetadata(params)
        .then((res) => {
          message.success(res.data.message);
          dataInfo.value.disBtn = false;
          Cancel();
        })
        .catch((res) => {
          dataInfo.value.disBtn = false;
          message.error(res.data.error);
        });
    }
  }
  if (dataInfo.value.source == 1) {
    // 腾讯剪辑
    dataInfo.value.leftMovePercentage = String(dataInfo.value.leftMovePercentage).replace(/^(.*\..{4}).*$/, '$1');
    dataInfo.value.rightMovePercentage = String(dataInfo.value.rightMovePercentage).replace(/^(.*\..{4}).*$/, '$1');
    let duration = dataInfo.value.rightMovePercentage - dataInfo.value.leftMovePercentage;
    if (dataInfo.value.leftMovePercentage == 0 && dataInfo.value.rightMovePercentage == 0) {
      message.error('你还没有操作剪辑,无法进行保存！');
    } else {
      dataInfo.value.disBtn = true;
      let params = {
        video_id: dataInfo.value.video_id,
        title: dataInfo.value.project_title,
        start_time: dataInfo.value.videoEdit.start,
        end_time: dataInfo.value.videoEdit.end,
      };
      http
        .tencent_clip_synthesis(params)
        .then((res) => {
          message.success(res.data.message);
          dataInfo.value.disBtn = false;
          Cancel();
        })
        .catch((res) => {
          dataInfo.value.disBtn = false;
          message.error(res.data.error);
        });
    }
  }
};

initCreate();

const welcomeVideo = ref();
const videoWrapRef = ref();

onMounted(async () => {
  if (!homeStore.onVideojs) {
    await loadVideojs();
    homeStore.onVideojs = true;
  }

  if (!document.getElementById('welcomeVideo')) {
    videoWrapRef.value.innerHTML = ` <video id="welcomeVideo" class="video-js vjs-matrix vjs-default-skin vjs-big-play-centered">
        </video>`;
  }
  window.onresize = () => {
    throttle(videoInit(), 300, '');
  };
  nextTick(() => {
    welcomeVideo.value = new window.videojs('welcomeVideo', {
      loop: true,
      controls: false,
      techOrder: ['html5'], //html5模式
      preload: 'auto',
      autoplay: true,
    });
    welcomeVideo.value.src({
      src: dataInfo.value.play_Url,
    });
  });
  nextTick(() => {
    videoInit();
  });
});

onUnmounted(() => {
  welcomeVideo.value.dispose();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_a_input, {
          type: "text",
          value: dataInfo.value.project_title,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataInfo.value.project_title) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(timeTranslate(dataInfo.value.videoEdit.duration)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        ref_key: "videoWrapRef",
        ref: videoWrapRef,
        class: "custom-video_video"
      }, _hoisted_9, 512)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", {
            style: {"width":"80px"},
            class: _normalizeClass({ active: dataInfo.value.direction == 'left' })
          }, _toDisplayString(_unref(inputStartLeftTime)) + ":" + _toDisplayString(_unref(inputStartCenterTime)) + ":" + _toDisplayString(_unref(inputStartRightTime)), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: "video-controls",
          onMousedown: _cache[9] || (_cache[9] = ($event: any) => (handleClick($event, initInfo.value.handleMoveDirection)))
        }, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "control-bars-mask left",
              "data-direction": "left",
              style: _normalizeStyle(`width:${dataInfo.value.leftMovePercentage}%;`)
            }, null, 4),
            _createElementVNode("div", {
              class: "control-bars-mask right",
              "data-direction": "right",
              style: _normalizeStyle(`width:${dataInfo.value.rightMovePercentage}%;`)
            }, null, 4),
            _createElementVNode("div", {
              class: _normalizeClass(["control-bars-progress", { animate: dataInfo.value.videoEdit.play }]),
              style: _normalizeStyle(`left:${dataInfo.value.videoEdit.currentPosition}%;`)
            }, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(timeTranslate(dataInfo.value.currentTime)), 1)
            ], 6),
            _createElementVNode("div", {
              class: "control-bars-wrapper",
              style: _normalizeStyle(`left:${dataInfo.value.leftMovePercentage}%;right:${dataInfo.value.rightMovePercentage}%;`)
            }, [
              _createElementVNode("div", {
                id: "move_left_icon",
                class: "control-bars-move left",
                onMousedown: _cache[1] || (_cache[1] = ($event: any) => (handleMoveDown($event, 'left'))),
                onKeyup: [
                  _cache[2] || (_cache[2] = _withKeys(($event: any) => (leftdot_left()), ["left"])),
                  _cache[3] || (_cache[3] = _withKeys(($event: any) => (leftdot_right()), ["right"]))
                ],
                onClick: _cache[4] || (_cache[4] = ($event: any) => (leftdotClick()))
              }, null, 32),
              _createElementVNode("div", {
                id: "move_right_icon",
                class: "control-bars-move right",
                onMousedown: _cache[5] || (_cache[5] = ($event: any) => (handleMoveDown($event, 'right'))),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (rightdotClick())),
                onKeyup: [
                  _cache[7] || (_cache[7] = _withKeys(($event: any) => (leftdot_left()), ["left"])),
                  _cache[8] || (_cache[8] = _withKeys(($event: any) => (leftdot_right()), ["right"]))
                ]
              }, null, 32)
            ], 4)
          ])
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", {
            style: {"width":"80px"},
            class: _normalizeClass({ active: dataInfo.value.direction == 'right' })
          }, _toDisplayString(_unref(inputEndLeftTime)) + ":" + _toDisplayString(_unref(inputEndCenterTime)) + ":" + _toDisplayString(_unref(inputEndRightTime)), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_a_button, {
          class: "toggle",
          onClick: togglePlayStatus
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 播放选中 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "toggle margin",
          onClick: reSet
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_a_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (Cancel()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "margin",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (saveEditing())),
          disabled: dataInfo.value.disBtn
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 保存 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})